/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { CustomProductState } from "@eisinc/App/Store/Reducers/ProductDetails/state";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ customProductState: CustomProductState }>;

export const DispatchSetProductVideos: HandlerType = (props: {
    readonly parameter: Readonly<{
        customProductState: CustomProductState;
    }>;
    dispatch: any;
}) => {
    props.dispatch({
        type: "Pages/ProductDetails/SetProductVideos",
        customProductState: props.parameter.customProductState,
    });
};

export const chain = [DispatchSetProductVideos];

const setProductVideos = createHandlerChainRunner(chain, "SetProductVideos");
export default setProductVideos;
